import * as React from "react"
import styled, { css } from "styled-components"
import MenuLinkTitle from "../MenuLinkTitle/MenuLinkTitle"
import MobileNavContext, { MobileNavContextType } from "./MobileNavContext"

const StyledMobileMenuItem = styled.div<{ isSubMenuItem: boolean }>`
  ${props =>
    props.isSubMenuItem
      ? css`
          padding-top: 32px;
          padding-left: 10px;
        `
      : css`
          padding-bottom: 32px;
        `}
`

interface Props {
  title: string
  linkTo?: string
  content?: React.ReactNode
  isSubMenuItem?: boolean
  externalLink?: boolean
}

const MobileMenuItem = ({
  title,
  linkTo,
  content,
  isSubMenuItem = false,
  externalLink = false,
}: Props) => {
  const { onClose } = React.useContext<MobileNavContextType>(MobileNavContext)

  const [isContentShown, setIsContentShown] = React.useState<boolean>(false)

  const isContentRendered = !!content && isContentShown

  const toggleContent = () => {
    if (isContentShown) {
      setIsContentShown(false)
    } else {
      setIsContentShown(true)
    }
  }

  const handleOnClick = () => {
    if (content) {
      toggleContent()
    } else {
      onClose()
    }
  }

  return (
    <StyledMobileMenuItem isSubMenuItem={isSubMenuItem}>
      <MenuLinkTitle
        title={title}
        withChevron={!!content}
        isOpen={isContentRendered}
        to={linkTo}
        onClick={handleOnClick}
        externalLink={externalLink}
      />
      {isContentRendered && content}
    </StyledMobileMenuItem>
  )
}

export default MobileMenuItem
